/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FormattedMessage } from 'react-intl-next';
import { Box, xcss } from '@atlaskit/primitives';
import LinkRenderType from '../../../issue-like-table/render-type/link';
var placeholderSmartLinkStyles = xcss({
  backgroundColor: 'elevation.surface.raised',
  borderRadius: "var(--ds-border-radius-200, 3px)",
  color: 'color.text.brand',
  paddingTop: 'space.0',
  paddingBottom: 'space.0',
  paddingLeft: 'space.025',
  paddingRight: 'space.025',
  boxShadow: 'elevation.shadow.raised'
});
var smartLinkContainerStyles = xcss({
  paddingLeft: 'space.025'
});
export var SmartCardPlaceholder = function SmartCardPlaceholder(_ref) {
  var placeholderText = _ref.placeholderText;
  return jsx(Box, {
    xcss: smartLinkContainerStyles
  }, jsx(Box, {
    as: "span",
    testId: "datasource-modal--smart-card-placeholder",
    xcss: placeholderSmartLinkStyles
  }, jsx(FormattedMessage, placeholderText)));
};
export var SmartLink = function SmartLink(_ref2) {
  var url = _ref2.url;
  return jsx(Box, {
    xcss: smartLinkContainerStyles
  }, jsx(LinkRenderType, {
    url: url
  }));
};